<template>
    <div class="cooperation">
        <div class="home_carousel">
            <div class="carousel_img">
                <div class="carousel_con">
                    <h2>与每一种力量</h2>
                    <h2>共筑智慧、便捷、美好生活</h2>
                    <div class="englishTitle">
                        <div>AND EVERY POWER</div>
                        <div>
                            BUILD A SMART, CONVENIENT AND BETTER LIFT TOGET PROCUREMENT
                            SOLUTIONS
                        </div>
                    </div>
                    <div class="line"></div>
                    <button @click="applyShow" class="btn">立即申请试用</button>
                </div>
                <div></div>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h1>招标公告</h1>
            </div>
            <div style="width: 60%;margin: 0 auto;">
                <el-row :gutter="20" >
                    <!-- <el-col :span="6"><div class="grid-content bg-purple"></div></el-col>
                    <el-col :span="6"><div class="grid-content bg-purple"></div></el-col>
                    <el-col :span="6"><div class="grid-content bg-purple"></div></el-col>
                    <el-col :span="6"><div class="grid-content bg-purple"></div></el-col>
                    <div  v-for="item in caseData" :key="item.id">
                        <div class="case_item">

                        </div>
                    </div> -->
                    <el-col :span="6" v-for="item in caseData" :key="item.id" >
                        <div @click="goDetail()">
                            <!-- <div class="case_img">
                                <img  :src="item.img" alt=""  style="width: 100%;display: block;"/>
                            </div> -->
                            <div class="case_item">
                                <div style="padding: 10px;">
                                    <div class="title">{{ item.title }}</div>
                                    <div class="time">{{ item.time }}</div>
                                    <div class="time" style="font-weight: 400;">{{ item.content }}</div>
                                    <div class="btnn">查看详情<i class="el-icon-d-arrow-right"></i></div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <ApplyDialog :show.sync="show"></ApplyDialog>
    </div>
</template>

<script>
import SlideBar from "../components/sidebar.vue";
import ApplyDialog from "../components/applyDialog.vue";
export default {
    components: { SlideBar, ApplyDialog },
    data() {
        return {
            show: false,
            caseData: [
                {
                    img: require("../assets/ht.png"),
                    title: "员工食堂食材配送服务 中标公告",
                    content:
                        "员工食堂食材配送服务 中标公告",
                    type: "0",
                    time: '2023-03-10',
                },
            ],
        };
    },
    methods: {
        applyShow() {
            this.show = true;
            // 禁止滚动
            this.noScroll();
        },
        goDetail(){
            this.$router.push({
                path: '/notices/details',
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.cooperation {
    width: 100%;
    height: 100%;
    position: relative;

    .home_carousel {
        width: 100%;

        .carousel_img {
            background: url("../assets/cooperation6.png") no-repeat center center;
            background-size: cover;
            height: 100%;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 7.5rem 2.5rem 7.5rem;
            height: 40.3125rem;

            .carousel_con {
                display: block;
                width: 48%;
                animation: fadenum 2s;

                &>h2 {
                    font-size: 2.125rem;
                    font-weight: bold;
                    color: #ffffff;
                }

                .englishTitle {
                    font-size: 0.75rem;
                    font-weight: 400;
                    color: #ffffff;
                    margin-top: 3.875rem;
                }

                .line {
                    width: 1.875rem;
                    height: 0.25rem;
                    background: #0e6eb8;
                    margin: 2.5rem 0;
                }

                &>button {
                    font-size: 1.25rem;
                    font-weight: bold;
                    background: none;
                    color: #2777b9;
                    padding: 1.1875rem 1.9375rem;
                    border-radius: 0.25rem;
                    border: 2px solid #2777b9;
                    cursor: pointer;
                }

                &>button:hover {
                    background: #0e6eb8;
                    color: #ffffff;
                    transition: .2s;
                }
            }

            @keyframes fadenum {
                0% {
                    transform: translateX(-150px);
                }
            }
        }
    }
    .case_img {
        overflow: hidden;
    }

    .case_img img{
        transition: all 0.8s;
    }
    .case_img img:hover{
        transform: scale(1.2);
    }

    .content {
        background-color: #ffffff;
        padding-bottom: 32px;

        .title h1 {
            text-align: center;
            font-size: 2.5rem;
            font-weight: bold;
            padding: 6.25rem 0 3.75rem 0;
        }


        .case_item {
            padding: 5px;
            width: 100%;
            background: rgb(243, 243, 243);

            .title {
                display: -webkit-box;
                -webkit-line-clamp: 2; /* 显示的行数 */
                -webkit-box-orient: vertical;
                overflow: hidden;
                margin-bottom: 5px;
            }

            .time {
                padding-bottom: 15px;
                color: #555555;
                font-size: 16px;
                font-weight: 350;
            }

            .btnn {
                color: #161d27;
                font-size: 14px;
                padding-bottom: 10px;
                border-bottom: 1px solid;
                border-bottom-color: #0e6eb8;
                width: fit-content;
                transition: all 0.5s;
            }

            .btnn:hover {
                color: #0e6eb8;
            }
        }

        .grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 10px; /* 格子之间的间隙 */
        }
        
        .grid-row {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 10px; /* 格子之间的间隙 */
        }
        
        .grid-cell {
            border: 1px solid #ccc; /* 格子边框 */
            text-align: center;
            line-height: 50px; /* 单元格内容垂直居中 */
            font-size: 20px;
        }







        .caseBox {
            display: flex;
            justify-content: space-around;
            // margin: 0 9.375rem;
            margin: 1rem 7.5rem 2.5rem 7.5rem;
            border: 0.125rem solid #eeeeee;
            box-shadow: 0px 0px 2.5rem 0px rgba(1, 37, 64, 0.08);
            border-radius: 0.625rem;
            padding: 3.125rem 2.5rem;
            margin-bottom: 3.125rem;
            overflow: hidden;

            .caseImg {
                transition: all 1s linear 0.1s;

                img {
                    width: 25rem;
                    height: 13.75rem;
                }
            }

            .caseImg:hover {
                transform: scale(1.3);
            }

            .caseContent {
                display: flex;
                flex-direction: column;
                // justify-content: space-between;
                width: 25rem;

                .name {
                    font-size: 1.75rem;
                    font-weight: bold;
                    color: #333333;
                    margin-bottom: 1.875rem;

                    &.end {
                        display: flex;
                        justify-content: flex-end;
                        font-size: 1.75rem;
                        font-weight: bold;
                        color: #333333;
                        margin-bottom: 1.875rem;
                    }
                }
            }

            .line {
                height: 0.0625rem;
                background: #eeeeee;
                margin-bottom: 3.75rem;
            }

            .message {
                position: relative;
                font-size: 1rem;
                font-weight: 400;
                color: #666666;

                .front {
                    position: absolute;
                    top: -2.8125rem;
                    left: 0px;

                    &>img {
                        width: 3.875rem;
                        height: 2.375rem;
                    }
                }

                .back {
                    position: absolute;
                    right: 0;

                    &>img {
                        width: 3.875rem;
                        height: 2.375rem;
                    }
                }
            }
        }
    }
}
</style>
<style lang="scss">@media screen and (max-width: 600px) {

    html,
    body {
        width: 100vw;
        overflow: auto;
    }

    .home_carousel {
        margin-top: 70px !important;
    }

    .caseBox {
        align-items: center !important;
    }

    .back,
    .front {
        img {
            width: 3.125rem;
            height: 3.125rem;
        }
    }
}</style>